<template>
	<BaseCenteredPage v-if="isValidatingRedirect">
		<BaseIcon name="mono/load" class="h-24 w-24 my-auto" />
	</BaseCenteredPage>
	<BaseCenteredMessage v-else-if="isValidRedirect && client && $store.workspaces.length">
		<template #icon>
			<div class="flex justify-center items-center gap-8">
				<BaseIcon name="bird" class="w-32 h-32" />
				<BaseIcon name="mono/bidirectional-arrows" class="h-32 w-32" />
				<img :src="client.logo" width="32" height="32" />
			</div>
		</template>
		<template #title>
			Select a workspace to connect to <span class="capitalize">{{ client.name }}</span>
		</template>
		<template #details>
			<p>
				This will grant
				<span class="capitalize">{{ client.name }}</span>
				{{ ' ' }}
				<span v-if="$route.query.scope">{{ $route.query.scope }}</span>
				access to the selected {{ $store.productName }} workspace
			</p>
			<BaseSelect
				v-model="selectedWorkspaceId"
				:options="workspaces"
				labelProp="name"
				valueProp="id"
				placeholder="Select a workspace"
				mode="single"
				closeOnSelect
				class="mt-24"
				style="max-width: 320px"
			/>
		</template>
		<template #actions>
			<BaseButton
				:disabled="!selectedWorkspaceId"
				:loading="isConnecting"
				class="button-green"
				@click="getAuthorizationCodeAndRedirect"
			>
				Connect to<span class="capitalize">{{ client.name }}</span>
			</BaseButton>
			<button class="flex mx-auto mt-20 link-white text-strong-base" @click="denyAccess">Deny Access</button>
		</template>
	</BaseCenteredMessage>
	<BaseCenteredMessage v-else hideActions>
		<template #icon>
			<img src="../../../shared/img/bird-nervous.svg" alt="error image" />
		</template>
		<template #title>Error</template>
		<template #details>{{ errorMessage }}</template>
	</BaseCenteredMessage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'
import analytics from 'shared/utils/analytics'
import createQueryString from 'shared/utils/createQueryString'

export default {
	name: 'OAuthAuthorize',
	setup() {
		useTitle('OAuth Authorize')
	},
	data() {
		return {
			isValidatingRedirect: true,
			isValidRedirect: false,
			isConnecting: false,
			errorMessage: '',
			client: undefined,
			selectedWorkspaceId: undefined,
		}
	},
	computed: {
		workspaces() {
			return this.$store.userWorkspaces.map(({workspace}) => workspace)
		},
	},
	mounted() {
		analytics.page('OAuth Authorize')
		this.validateRedirect()
	},
	methods: {
		async validateRedirect() {
			try {
				const queryObject = {
					client_id: this.$route.query.client_id,
					redirect_uri: this.$route.query.redirect_uri,
					response_type: this.$route.query.response_type,
					scope: this.$route.query.scope,
				}
				const queryString = createQueryString(queryObject)
				this.client = await this.$api.get('/oauth/validate-redirect' + queryString)
				this.isValidRedirect = true
			} catch (error) {
				this.errorMessage = error.message || 'Something went wrong'
				throw error
			} finally {
				this.isValidatingRedirect = false
			}
		},
		async getAuthorizationCodeAndRedirect() {
			this.isConnecting = true
			try {
				const queryString = createQueryString({
					client_id: this.$route.query.client_id,
					redirect_uri: this.$route.query.redirect_uri,
					response_type: this.$route.query.response_type,
					workspaceId: this.selectedWorkspaceId,
				})
				const data = await this.$api.get('/oauth/code' + queryString)
				window.open(
					`${this.$route.query.redirect_uri}?state=${this.$route.query.state}&client_id=${this.$route.query.client_id}&code=${data.code}`,
					'_self'
				)
			} catch (error) {
				this.isValidRedirect = false
				this.isConnecting = false
				this.errorMessage = error.message
				throw error
			}
		},
		denyAccess() {
			window.open(
				`${this.$route.query.redirect_uri}?state=${this.$route.query.state}&client_id=${this.$route.query.client_id}&code=denied`,
				'_self'
			)
		},
	},
}
</script>
